import { render, staticRenderFns } from "./RotationCard.vue?vue&type=template&id=5bcd7c7e&scoped=true"
import script from "./RotationCard.vue?vue&type=script&lang=js"
export * from "./RotationCard.vue?vue&type=script&lang=js"
import style0 from "./RotationCard.vue?vue&type=style&index=0&id=5bcd7c7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd7c7e",
  null
  
)

export default component.exports